import { RQ } from 'utils';
import { share } from 'utils/wx';
import config from 'config';

export default {
  getInfo: async function () {
    var self = this;

    var d = await RQ.mall.get(
      '/api/app/enterprise/property/getEnterpriseProperty',
      {
        enterpriseNo: self.enterpriseNo,
        isPlatform: this.params.is_platform
      },
      { enterprise: self.enterpriseNo }
    );
    if (d && d.code == 0) {
      self.androidDownload = d.data.androidDownload;
      self.iosDownload = d.data.iosDownload;
    } else {
      self.tips(d.msg, 1500);
    }
    return d;
  },

  downLoadApp: async function () {
    var self = this;
    var userAgent = navigator.userAgent;
    var phoneType = userAgent.indexOf('iPhone') > -1 ? 'iPhone' : 'android';
    var isWeChat = userAgent.indexOf('MicroMessenger') > -1;
    if (!this.androidDownload) {
      await self.getInfo();
    }
    if (phoneType == 'android') {
      if (isWeChat) {
        alert('点击微信右上角按钮，然后在弹窗的菜单中，点击在浏览器中打开，即可安装');
      } else {
        window.location.href = this.androidDownload;
      }
    } else {
      window.location.href = this.iosDownload;
    }
  },

  addShare(to) {
    share(to, {
      title: '下载APP',
      desc: '下载APP',
      link: location.origin + to.fullPath,
      imgUrl: '',
      type: 'link' // 分享类型,music、video或link，不填默认为link
    });
  }
};



// WEBPACK FOOTER //
// ./src/module/app/download/action.js